module.exports = __webpack_public_path__ + "static/media/mobile.e7bb0036.png";